import { Main } from "@quest/murka-games-behavior-panther/dist"

export class MainGame extends Main {
    
}
